var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverPortalDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 190,
    viewBox: "0 0 197 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19899_2780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7441 -177.368C79.4971 -222.678 185.753 -218.754 229.998 -204.429C274.243 -190.103 279.844 -144.966 299.213 -91.4149C318.581 -37.8641 324.272 130.711 290.898 171.601C242.598 191.79 106.813 128.365 38.1597 150.346C-25.152 170.616 -93.6153 205.497 -68.4153 154.285",
    fill: "url(#paint0_linear_19899_2780)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19899_2780",
    x: -77.9709,
    y: -214.143,
    width: 397.017,
    height: 403.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19899_2780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19899_2780",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19899_2780",
    x1: 29.2249,
    y1: 121.222,
    x2: 210.055,
    y2: 80.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A180FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverPortalDashboard);
export default __webpack_public_path__ + "static/media/hover_portal_dashboard.18109acb34efef0c0e71a89aa773f81e.svg";
export { ForwardRef as ReactComponent };